// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import cn from 'classnames';
import React, {useContext, useState} from 'react';
import {Settings_context} from '../settings_ctx';
import styles from './payment_form_hola2023_theme.module.less';
import {i_plan_extended} from './plus_types';
import plus_ui from '/www/hola/pub/plus_ui.js';
import modal from '/www/hola/pub/modal.js';
import {i_select_item, Select} from '../lib/select';
import {use_qs} from '../lib/use_qs';
import '@adyen/adyen-web/styles/adyen.css';
// @ts-ignore
import {format_price} from '/util/country.js';
// @ts-ignore
import {get_price_plan, parse_period}
    from '../../../../svc/account/pub/membership.js';
import Icon_hola_premium from '../img/plus/hola_premium.svg';
import {Lottie} from '../lib/lottie';
import {t_premium_page_opt} from '../ui/premium/use_premium_page';
import {perr} from 'hola_pub_util';

interface i_payment_form_props {
    opt: t_premium_page_opt;
    visible: boolean;
    cls?: string;
    limited_height?: number;
    on_click?: (ev:any)=>void;
    summary_test?: boolean;
    all_plans_test?: boolean;
    with_skeleton?: boolean;
    secured_elems_test?: boolean;
    payment_btn_on_top?: boolean;
    with_trial?: boolean;
    on_load?: ()=>void;
}

const plan_names = {
  '3 years': '3 years plan',
  'year': '1 year plan',
  'month': 'Monthly plan',
};
const period2months = {
    '1 M': 1,
    '6 M': 6,
    '1 Y': 12,
    '2 Y': 24,
    '3 Y': 36,
};

export const Payment_form = (props:i_payment_form_props)=>{
    const {opt, cls, on_click, summary_test, secured_elems_test,
      all_plans_test, with_skeleton, on_load, payment_btn_on_top,
      with_trial} = props;
    const {theme} = useContext(Settings_context);
    const [submitting, set_submitting] = useState(false);
    const [method_chosen, set_method_chosen] = useState(false);
    const [plan_selected, set_plan_selected] = useState(false);
    const [currency_selected, set_currency_selected] = useState(false);
    const {price, erf_amount} = get_price_plan(opt.plan, opt.currency);
    const price_string = format_price(opt.currency, price);
    const {count: free_period_count} = parse_period(opt.plan.free_period)||{};
    const plan_view = (plan: i_plan_extended)=>{
        const price_plan = get_price_plan(plan, opt.currency);
        const every_price = price_plan.month_price||price_plan.price;
        const every = price_plan.month_price ? 'month' : plan.every;
        const every_price_string = format_price(
            opt.currency, every_price);
        return <p className={cn(theme.bold, styles.plan_title)}>
          {plan_names[plan.every] || plan.name} - <br
            className={styles.plan_name_br}/> {every_price_string}
          <span className={cn(theme.P, theme.p3, styles.plan_period)}>
            {' '}/{every}
          </span>
        </p>;
    };
    const plans: i_select_item[] = opt.plans.map(plan=>({
        value: plan.id,
        title: plan_view(plan),
        rendered_item: plan_view(plan),
    }));
    const currencies: i_select_item[] = opt.currencies.map(c=>({
        value: c,
        title: <span className={styles.currency_item}>{c}</span>,
        rendered_item: <span className={styles.currency_item}>{c}</span>,
    }));
    const header_text = with_trial ? 'Free for 3 days trial, then billed as'+
          ` one payment of ${price_string}`
         : opt.plan.renewal_price && opt.plan.renewal_price !== opt.plan.price
        ? `Billed now as one payment of ${price_string}. This subscription `
          + `will automatically renew every 12 months at `
          + `${format_price(opt.currency, opt.plan.renewal_price)} until you `
          + `cancel.`
        : opt.plan.free_period?.endsWith(' M')
        ? `Only ${price_string} for the first `
            +`${free_period_count + 1} ${opt.plan.every}s`
        : `Billed as one payment of ${price_string}. This subscription at `
            +`this price will automatically renew every `
            +`${period2months[opt.plan.period]} months until you cancel.`;
    const erf_text = erf_amount && {'1 M': 1, '1 W': 1}[opt.plan.period]
        ? <React.Fragment>{' '}includes an exchange rate fee.</React.Fragment>
        : null;

    return <div className={cn(styles.root,
      summary_test && styles.with_summary)} onClick={on_click}>
      <div className={cn(styles.form, cls)}>
        <div className={cn(styles.header_container)}>
          <div className={cn(styles.header)}>
            <Icon_hola_premium className={styles.logo}/>
            <div className={styles.plan_selector_container}>
              <Select class_name={cn(styles.plan_selector)}
                hide_active={!all_plans_test}
                items={plans} value={opt.plan.id}
                selected={plan_view(opt.plan)} borderless={true}
                border_class_name={styles.select_border}
                field_cls={!plan_selected && styles.select_init_state}
                on_open={()=>{
                  perr({id: 'www_open_dropdown'});
                  set_plan_selected(true);
                }}
                on_select={(_, value)=>{
                  perr({id: 'www_change_plan'});
                  opt.set_plan(opt.plans.find(p=>p.id==value));
                }}/>
            </div>
            {opt.currencies.length > 1 &&
              <div className={styles.currency_select_container}>
                <Select items={currencies} value={opt.currency}
                  borderless={true} border_class_name={styles.select_border}
                  field_cls={!currency_selected && styles.select_init_state}
                  on_open={()=>{
                    perr({id: 'www_open_dropdown'});
                    set_currency_selected(true);
                  }}
                  hide_active={!all_plans_test}
                  on_select={(_, value)=>{
                    perr({id: 'www_change_plan'});
                    opt.set_currency(value);
                    }}/>
            </div>}
          </div>
          <div>
            <p className={cn(theme.p4)}>
              {header_text}
              {erf_text}
            </p>
          </div>
        </div>
        <div className={styles.content}>
          {opt.plan && <plus_ui.Step_payment is_hola2023
            with_trial={with_trial}
            expand="cc"
            with_skeleton={with_skeleton}
            selected_plan={opt.plan}
            slide_active
            email_in_cc
            no_currency_selector
            payment_btn_on_top={payment_btn_on_top}
            before_payment={()=>set_submitting(true)}
            after_payment={()=>set_submitting(false)}
            on_method_tab_change={(method, prov)=>{
              opt.set_provider(prov);
              if (method == 'other')
                opt.set_email('');
            }}
            on_load={on_load}
            set_method_chosen={set_method_chosen}
            method_chosen={method_chosen}
            secured_elems_test={secured_elems_test}
            checkout_text_test={true}
            summary_test={summary_test}
            adyen_props={opt}
            {...opt}/>}
        </div>
        {submitting && <div className={styles.loading_container}>
          <div className={styles.loading_overlay}></div>
          <Lottie width="375px" height="375px" autoplay loop
            src="/www/hola/pub/img/animation/ext_checkout_form_loader.json"/>
        </div>}
      </div>
    </div>;
};

export const Payment_form_modal = (props: i_payment_form_props)=>{
    const qs = use_qs();
    const adyen_test = !!qs.debug_cc_payment;
    if (!adyen_test)
        return <Payment_form {...props} />;
    const close = ()=>{ return null; };
    const url = '/payment_form_adyen';
    return <modal.Modal on_close={close} show={true} backdrop='static'
      keyboard={false}>
      <div className="modal-body">
        <iframe frameBorder="0" id='modal_payment_adyen' scrolling="no"
          className={styles.modal_payment_adyen} src={url} />
      </div>
    </modal.Modal>;
};
